import { React } from "react";
import { useNavigate } from "react-router";

import "./TopLinks.css";

const TopLinks = ({ links }) => {
  const navigate = useNavigate();

  const handleClick = (key) => {
    if (!links[key].isCurrent) {
      //   if (links[key].isPrevious) history.goBack();
      //   else history.push(links[key].path);
      navigate(links[key]?.path);
    }
  };

  const BuildArrow = (props) => {
    const arr = props.array;
    const index = props.index;

    if (index === arr.length - 1) return <div></div>;
    else return <div className="arrow">&rarr;</div>;
  };

  return (
    <div className="top-link-container">
      {links.map((link, key) => (
        <div key={"top-link" + key} className={"link-item-wrapper"}>
          <div
            className={link.isCurrent ? "link-item-current" : "link-item"}
            key={"link" + key}
            onClick={() => {
              handleClick(key);
            }}
          >
            {link.name}
          </div>
          <BuildArrow index={key} array={links} />
        </div>
      ))}
    </div>
  );
};

export default TopLinks;
